import { CurrencyType } from '@wolffun/system-currency';
import { BUSD_CONTRACT_ADDRESS, THETAN_COIN_CONTRACT_ADDRESS, THETAN_GEM_CONTRACT_ADDRESS, WBNB_CONTRACT_ADDRESS } from 'src/constants';
import { NtfHeroClassType } from '@wolffun/shared/src/types';
import { BUSDT_CONTRACT_ADDRESS } from '@wolffun/shared/constants';
export { currencyIconMap, itemIconMap } from '@wolffun/shared/src/types';
export { BoxTypeName, NftRefType, NftSkinItemRarity, NftItemRarity, currencyName, HeroStatus, WalletProvider, BoxType, NtfHeroClassType, GiftBoxType } from '@wolffun/shared/src/types';
export let HeroTrophy;

(function (HeroTrophy) {
  HeroTrophy[HeroTrophy["H"] = 1] = "H";
  HeroTrophy[HeroTrophy["G"] = 2] = "G";
  HeroTrophy[HeroTrophy["F"] = 3] = "F";
  HeroTrophy[HeroTrophy["E"] = 4] = "E";
  HeroTrophy[HeroTrophy["D"] = 5] = "D";
  HeroTrophy[HeroTrophy["C"] = 6] = "C";
  HeroTrophy[HeroTrophy["B"] = 7] = "B";
  HeroTrophy[HeroTrophy["A"] = 8] = "A";
  HeroTrophy[HeroTrophy["S"] = 9] = "S";
  HeroTrophy[HeroTrophy["SS"] = 10] = "SS";
})(HeroTrophy || (HeroTrophy = {}));

export let RankMedal;

(function (RankMedal) {
  RankMedal[RankMedal["TUTORIAL"] = 0] = "TUTORIAL";
  RankMedal[RankMedal["RECRUIT"] = 1] = "RECRUIT";
  RankMedal[RankMedal["PRIVATE"] = 2] = "PRIVATE";
  RankMedal[RankMedal["BRONZE"] = 3] = "BRONZE";
  RankMedal[RankMedal["SILVER"] = 4] = "SILVER";
  RankMedal[RankMedal["GOLD"] = 5] = "GOLD";
  RankMedal[RankMedal["PLATINUM"] = 6] = "PLATINUM";
  RankMedal[RankMedal["DIAMOND"] = 7] = "DIAMOND";
  RankMedal[RankMedal["MASTER"] = 8] = "MASTER";
  RankMedal[RankMedal["CHAMPION"] = 9] = "CHAMPION";
  RankMedal[RankMedal["SUPER_CHAMPION"] = 10] = "SUPER_CHAMPION";
})(RankMedal || (RankMedal = {}));

export const HeroClassName = {
  [NtfHeroClassType.TANK]: 'Tank',
  [NtfHeroClassType.ASSASSIN]: 'Assassin',
  [NtfHeroClassType.MARKSMAN]: 'Marksman'
};
export let NftStatus;

(function (NftStatus) {
  NftStatus[NftStatus["DEFAULT"] = 1] = "DEFAULT";
  NftStatus[NftStatus["NOT_MINT"] = 0] = "NOT_MINT";
})(NftStatus || (NftStatus = {}));

export let NftHeroRole;

(function (NftHeroRole) {
  NftHeroRole["ASSASSIN"] = "ASSASSIN";
})(NftHeroRole || (NftHeroRole = {}));

export let BoxRarity;

(function (BoxRarity) {
  BoxRarity["COMMON"] = "common";
  BoxRarity["EPIC"] = "epic";
  BoxRarity["LEGENDARY"] = "legendary";
  BoxRarity["SEASON"] = "season";
  BoxRarity["LUNAR"] = "lunar";
  BoxRarity["SPECIAL"] = "special";
})(BoxRarity || (BoxRarity = {}));

export let UserStatus;

(function (UserStatus) {
  UserStatus[UserStatus["Active"] = 1] = "Active";
  UserStatus[UserStatus["Banned"] = -1] = "Banned";
})(UserStatus || (UserStatus = {}));

export const contractAddress = {
  [CurrencyType.BUSD]: BUSD_CONTRACT_ADDRESS,
  [CurrencyType.BUSDT]: BUSDT_CONTRACT_ADDRESS,
  [CurrencyType.THC]: THETAN_COIN_CONTRACT_ADDRESS,
  [CurrencyType.THG]: THETAN_GEM_CONTRACT_ADDRESS,
  [CurrencyType.GTHG]: '',
  [CurrencyType.GTHC]: '',
  [CurrencyType.WBNB]: WBNB_CONTRACT_ADDRESS,
  [CurrencyType.BNB]: '',
  [CurrencyType.GPP]: '',
  [CurrencyType.GPT]: '',
  [CurrencyType.GOLD]: '',
  [CurrencyType.GMQP]: ''
};
export let SortClaimBoxHistory;

(function (SortClaimBoxHistory) {
  SortClaimBoxHistory["TokenAscending"] = "tokenAsc";
  SortClaimBoxHistory["TokenDescending"] = "tokenDesc";
  SortClaimBoxHistory["TimeAscending"] = "timeAsc";
  SortClaimBoxHistory["TimeDescending"] = "timeDesc";
})(SortClaimBoxHistory || (SortClaimBoxHistory = {}));

export let TimeFilterType;

(function (TimeFilterType) {
  TimeFilterType["TIME_ALL"] = "0";
  TimeFilterType["TIME_HOUR_1"] = "1";
  TimeFilterType["TIME_HOUR_24"] = "2";
  TimeFilterType["TIME_DAY_7"] = "3";
  TimeFilterType["TIME_DAY_14"] = "4";
  TimeFilterType["TIME_DAY_30"] = "5";
})(TimeFilterType || (TimeFilterType = {}));

export let MarketType;

(function (MarketType) {
  MarketType[MarketType["NOT_FOR_SALE"] = 0] = "NOT_FOR_SALE";
  MarketType[MarketType["SALE"] = 10] = "SALE";
  MarketType[MarketType["AUCTION"] = 20] = "AUCTION";
  MarketType[MarketType["FOR_RENT"] = 30] = "FOR_RENT";
  MarketType[MarketType["RENTED"] = 31] = "RENTED";
})(MarketType || (MarketType = {}));

export { CosmeticType, CosmeticRarity, CosmeticRefType, BoxConfigRefType, CosmeticStatus } from '@wolffun/shared/src/types';
export let ProjectStatus;

(function (ProjectStatus) {
  ProjectStatus["LIVE"] = "live";
  ProjectStatus["UPCOMING"] = "upcoming";
  ProjectStatus["ENDED"] = "ended";
  ProjectStatus["INACTIVE"] = "inactive";
  ProjectStatus["REFUNDED"] = "refunded";
})(ProjectStatus || (ProjectStatus = {}));

export let UserProjectStatus;

(function (UserProjectStatus) {
  UserProjectStatus[UserProjectStatus["PENDING"] = 1] = "PENDING";
  UserProjectStatus[UserProjectStatus["COMPLETED"] = 2] = "COMPLETED";
})(UserProjectStatus || (UserProjectStatus = {}));

export let AllowListStatus;

(function (AllowListStatus) {
  AllowListStatus["SOON"] = "soon";
  AllowListStatus["OPEN"] = "open";
  AllowListStatus["CLOSED"] = "closed";
  AllowListStatus["REFUNDED"] = "refunded";
})(AllowListStatus || (AllowListStatus = {}));

export let Blockchain;

(function (Blockchain) {
  Blockchain["ETHEREUM"] = "ethereum";
  Blockchain["BINANCE"] = "binance";
  Blockchain["POLYGON"] = "polygon";
  Blockchain["AVALANCHE"] = "avalanche";
  Blockchain["CELO"] = "celo";
  Blockchain["SOLANA"] = "solana";
  Blockchain["FANTOM"] = "fantom";
})(Blockchain || (Blockchain = {}));

export let EventType;
/** eslint@typescript-eslint/ban-types
 * Don't use `{}` as a type. `{}` actually means "any non-nullish value".
 * - If you want a type meaning "any object", you probably want `Record<string, unknown>` instead.
 * - If you want a type meaning "any value", you probably want `unknown` instead.
 * - If you want a type meaning "empty object", you probably want `Record<string, never>` instead.
 */

(function (EventType) {
  EventType[EventType["TOURNAMENT_EVENT"] = 1] = "TOURNAMENT_EVENT";
  EventType[EventType["LIST_TOURNAMENT_EVENT"] = 2] = "LIST_TOURNAMENT_EVENT";
  EventType[EventType["HERO_FUSION_EVENT"] = 3] = "HERO_FUSION_EVENT";
  EventType[EventType["COINBASE_LOOT"] = 4] = "COINBASE_LOOT";
  EventType[EventType["TRADING_EVENT"] = 5] = "TRADING_EVENT";
  EventType[EventType["GIFTMAS_FORTUNE_WHEEL_EVENT"] = 7] = "GIFTMAS_FORTUNE_WHEEL_EVENT";
  EventType[EventType["SAMSUNG_EVENT"] = 8] = "SAMSUNG_EVENT";
})(EventType || (EventType = {}));

export let BundleBoxType;

(function (BundleBoxType) {
  BundleBoxType[BundleBoxType["CHEF_OCTOPUS"] = 10] = "CHEF_OCTOPUS";
  BundleBoxType[BundleBoxType["HAT_TRICK_BUNDLE"] = 19] = "HAT_TRICK_BUNDLE";
  BundleBoxType[BundleBoxType["MYTHICAL_CHRISTMAS"] = 25] = "MYTHICAL_CHRISTMAS";
  BundleBoxType[BundleBoxType["PREMIUM_LEGENDARY"] = 26] = "PREMIUM_LEGENDARY";
})(BundleBoxType || (BundleBoxType = {}));

export let TradingQuestType;

(function (TradingQuestType) {
  TradingQuestType[TradingQuestType["HERO_TROPHY_CLASS"] = 1] = "HERO_TROPHY_CLASS";
  TradingQuestType[TradingQuestType["HERO_LEVEL"] = 2] = "HERO_LEVEL";
  TradingQuestType[TradingQuestType["HERO_CLASS"] = 3] = "HERO_CLASS";
  TradingQuestType[TradingQuestType["SKIN_RARITY"] = 4] = "SKIN_RARITY";
  TradingQuestType[TradingQuestType["ALL_HERO"] = 5] = "ALL_HERO";
})(TradingQuestType || (TradingQuestType = {}));

export let CategoryKey;

(function (CategoryKey) {
  CategoryKey["Heroes"] = "heroes";
  CategoryKey["Pets"] = "pets";
  CategoryKey["ThetaBox"] = "thetabox";
  CategoryKey["GiftBox"] = "giftbox";
  CategoryKey["Cosmetic"] = "cosmetic";
  CategoryKey["Others"] = "others";
})(CategoryKey || (CategoryKey = {}));

export let InGameCategoryKey;

(function (InGameCategoryKey) {
  InGameCategoryKey["BattleRewards"] = "battle_rewards";
})(InGameCategoryKey || (InGameCategoryKey = {}));